import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { categories } from '../data/mockData';
import { Card } from './Card';
export function CategorySection() {
  return <section className="py-24 px-4 bg-bg-secondary" data-id="element-43">
      <div className="max-w-6xl mx-auto" data-id="element-44">
        <div className="text-center mb-16" data-id="element-45">
          <h2 className="text-4xl md:text-5xl font-heading uppercase tracking-wide text-white mb-4" data-id="element-46">
            Categorías
          </h2>
          <p className="font-body text-text-secondary text-lg" data-id="element-47">
            Encontrá exactamente lo que se te antoja
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6" data-id="element-48">
          {categories.map((category, index) => {
          // @ts-ignore
          const Icon = Icons[category.icon] || Icons.UtensilsIcon;
          return <motion.div key={category.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="cursor-pointer group" data-id="element-49">
                <Card className="h-full p-6 flex flex-col items-center text-center" data-id="element-50">
                  <div className="w-14 h-14 rounded-full bg-brand-gold/10 border border-brand-gold/20 flex items-center justify-center mb-4 group-hover:bg-brand-gold/20 transition-colors" data-id="element-51">
                    <Icon className="w-7 h-7 text-brand-gold" data-id="element-52" />
                  </div>
                  <h3 className="font-body font-bold text-white mb-1" data-id="element-53">
                    {category.name}
                  </h3>
                  <p className="font-body text-xs text-text-muted" data-id="element-54">
                    {category.count} lugares
                  </p>
                </Card>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}